module.exports = __webpack_public_path__ + "static/media/hourglass-half.1fef2225.svg";